const AUTH_RETURN_URL_KEY = "auth_return_url";

const EMPLOYEE_PATH_PREFIX = "/employee";

export const isSafeReturnUrl = (path) => {
  if (!path || typeof path !== "string") return false;

  const trimmed = path.trim();
  if (!trimmed.startsWith("/") || trimmed.startsWith("//")) return false;
  if (/^https?:\/\//i.test(trimmed)) return false;

  return trimmed === EMPLOYEE_PATH_PREFIX || trimmed.startsWith(`${EMPLOYEE_PATH_PREFIX}/`);
};

export const saveReturnUrl = (url) => {
  if (!isSafeReturnUrl(url)) return;
  sessionStorage.setItem(AUTH_RETURN_URL_KEY, url.trim());
};

export const getAndClearReturnUrl = (fallback = "/employee") => {
  const stored = sessionStorage.getItem(AUTH_RETURN_URL_KEY);
  sessionStorage.removeItem(AUTH_RETURN_URL_KEY);

  if (stored && isSafeReturnUrl(stored)) return stored;
  return fallback;
};
